import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface Prop {
  isSent?: boolean;
  isDeleteUserPage?: boolean;
  isForgotPasswordPage?: boolean;
  isForgotPasswordSent?: boolean;
  isLoginPage?: boolean;
  isResetPasswordPage?: boolean;
  isSignupPage?: boolean;
}

const Group = styled.div<Prop>`
  width: 100%;
  height: 100dvh;
  overflow: auto;
  margin: auto;
  background-color: var(--background-secondary);
  display: flex;
  align-items: center;
  justify-content: center;

  ${(Props: Prop) =>
    Props.isDeleteUserPage &&
    css`
      ${mobile_xl(css`
        min-height: 382px;
      `)}
    `}
  ${(Props: Prop) =>
    Props.isForgotPasswordPage &&
    css`
      ${mobile_xl(css`
        min-height: 384px;
      `)}
    `}
     ${(Props: Prop) =>
    (Props.isLoginPage || Props.isResetPasswordPage) &&
    css`
      ${mobile_xl(css`
        min-height: 465px;
      `)}
    `}
      ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      ${mobile_xl(css`
        min-height: 556px;
      `)}
    `}
`;
const Content = styled.div<Prop>`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  background-color: var(--background-secondary);
  ${(Props: Prop) =>
    Props.isSent &&
    css`
      width: 100%;
      max-width: 100%;
      justify-content: center;
    `}

  ${mobile_xl(css`
    max-width: 100%;
    padding: 30px 16px;
  `)}
  ${(Props: Prop) =>
    Props.isLoginPage &&
    css`
      gap: 80px;
      align-items: unset;
      ${mobile_xl(css`
        gap: 30px;
      `)}
    `}
  ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      max-width: 582px;
      gap: 46px;
      ${mobile_xl(css`
        max-width: 100%;
        padding: 30px 24px;
        gap: 30px;
      `)}
    `}
`;

const Icon = styled.div`
  ${mobile_xl(css`
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;
const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: 0;
  text-align: center;
  ${mobile_xl(css`
    align-items: center;
  `)}
`;
const Form = styled.form<Prop>`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 20px;
  ${mobile_xl(css`
    gap: 30px;
  `)}
  ${(Props: Prop) =>
    Props.isLoginPage &&
    css`
      width: 100%;
      max-width: 300px;
      flex-direction: column;
      ${mobile_xl(css`
        max-width: 100%;
        gap: 16px;
      `)}
    `}
`;
const FormBlock = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;
const InputValue = styled.input`
  ${Typography.body_lg}
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  padding: 12px 16px;
  border-radius: 4px;
  outline: none;

  :focus {
    border: 0.5px solid var(--brand-primary);
    z-index: 999;
  }
  ::placeholder {
    ${Typography.body_lg}
    color: var(--border-secondary);
  }
  ${(Props: Prop) =>
    (Props.isLoginPage || Props.isResetPasswordPage || Props.isSignupPage) &&
    css`
      border-radius: 4px 4px 0px 0px;
      &.password {
        border-radius: 0px;
        margin-top: -1px;
      }
      &.password-input {
        border-radius: 0px 0px 4px 4px;
        margin-top: -1px;
      }
    `}
`;

const FormTextArea = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  ${(Props: Prop) =>
    Props.isResetPasswordPage &&
    css`
      gap: 6px;
      margin-top: 50px;
      ${mobile_xl(css`
        margin-top: 0;
      `)}
    `}
`;

const FormText = styled.p<Prop>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
  ${(Props: Prop) =>
    Props.isSent &&
    css`
      text-align: center;
      max-width: 560px;
      ${mobile_xl(css`
        margin-bottom: 10px;
      `)}
    `}

  ${(Props: Prop) =>
    Props.isForgotPasswordSent &&
    css`
      text-align: center;
      ${mobile_xl(css`
        margin-bottom: 10px;
      `)}
    `}
`;

const FormText1 = styled.p`
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  margin: 0;
`;

const Viewer = styled.a`
  cursor: pointer;
  color: var(--brand-primary);
  text-decoration: none;
  ${Typography.body_md_medium}
  ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      ${Typography.body_sm_medium}
    `}
`;

const FormView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  ${mobile_xl(css`
    gap: 30px;
  `)}
`;

const ResetView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${mobile_xl(css`
    align-items: center;
  `)}
`;
const TopView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
  max-width: 300px;
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;

const Formview = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mobile_xl(css`
    flex-direction: column;
    gap: 30px;
    align-items: flex-end;
  `)}
`;

const FormTextPoint = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
`;
const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  ${mobile_xl(css`
    width: 100%;
    gap: 15px;
  `)}
`;
const TextLine = styled.p`
  ${Typography.body_sm}
  color: var(--text-secondary);
  margin: 0;
  ${mobile_xl(css`
    text-align: center;
  `)}
`;
export {
  Group,
  Content,
  Icon,
  Title,
  FormBlock,
  Form,
  InputValue,
  FormTextArea,
  FormText,
  Viewer,
  FormText1,
  FormView,
  ResetView,
  TopView,
  Formview,
  FormTextPoint,
  FormContent,
  TextLine
};
